import { Observable } from 'rxjs';

export abstract class PushNotificationConfigService {
  abstract getAccessToken(): string;
  abstract token$: Observable<string>;
  abstract get authUrl(): string;
  abstract get pusherKey(): string;
  abstract get pusherCluster(): string;
}
